/* eslint-disable max-len */
import React from 'react';

function PurpleAngleShortRightSVG(props) {
  return (
    <svg width={1301} height={303} viewBox='0 0 1301 303' fill='none' {...props}>
      <path
        transform='rotate(-9.343 .113 219.113)'
        fill='url(#prefix__paint0_linear-01)'
        d='M.113 219.113h1346.19v85H.113z'
      />
      <defs>
        <linearGradient
          id='prefix__paint0_linear-01'
          x1={1345.01}
          y1={262.528}
          x2={293.669}
          y2={286.073}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#8298FC' />
          <stop offset={1} stopColor='#8298FC' stopOpacity={0} />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default PurpleAngleShortRightSVG;
